import { Trans } from "@lingui/react/macro";
import {
  Button,
  ButtonsContainer,
  DescriptionTextColumn,
  DescriptionTextColumnContent,
  DescriptionTextColumnContentLeft,
  DescriptionTextColumnContentRight,
  DescriptionTextColumnTitle,
  SectionContainer
} from "@silversea-ssc/ui-components-react";
import TextBox from "components/TextBox/TextBox";
import React from "react";
import {
  CruiseSectionShipFragment,
  CruiseSectionShipVersionFragment
} from "types/graphql-types";
import * as styles from "./ShipIntro.module.scss";
import { isPresent } from "src/utils/checks";
import { ECommerceStatus } from "src/ssc-api/useECommerceStatus";
import { NewEcommerceButton } from "components/ECommerceButtons";
const ResponsiveSlideshow = React.lazy(
  () => import("components/Slideshow/ResponsiveSlideshow")
);

type Props = {
  ship: CruiseSectionShipFragment;
  shipVersion: CruiseSectionShipVersionFragment;
  ecommerceStatus?: ECommerceStatus;
};

const ShipIntro: React.FC<Props> = ({ ship, shipVersion, ecommerceStatus }) => {
  const slideshow = shipVersion.slideshow?.filter(isPresent);

  return (
    <SectionContainer
      spacingTop="regular"
      spacingBottom="regular"
      backgroundColor="white"
      dataContentName="section_ship"
    >
      <DescriptionTextColumn>
        <DescriptionTextColumnContent>
          <DescriptionTextColumnContentLeft>
            <DescriptionTextColumnTitle>
              <Trans>Ship</Trans> - {ship.name}
            </DescriptionTextColumnTitle>

            <TextBox
              fontSize="medium"
              content={shipVersion.description?.content?.localized}
            />
            <div className={styles.discoverMoreShipPrint}>
              {ship.fullPath && (
                <React.Fragment>
                  <Trans>Ship Details</Trans>:{" "}
                  <a href={`https://www.silversea.com${ship.fullPath}`}>
                    https://www.silversea.com{ship.fullPath}
                  </a>
                </React.Fragment>
              )}
            </div>

            <ButtonsContainer spacingTop="regular" align="left">
              <NewEcommerceButton
                disableRAQ
                ecommerceStatus={ecommerceStatus}
                raqUrl={undefined}
                size="regular"
              />

              {shipVersion.deckPlanPdf && (
                <Button
                  href={shipVersion.deckPlanPdf?.asset?.url}
                  variant="secondary"
                  iconName="download"
                  target="_blank"
                  dataContentPiece="download_deck_plan"
                  dataContentParams={{ shipName: ship.name }}
                  rel="nofollow noopener"
                >
                  <Trans>View Deck Plan</Trans>
                </Button>
              )}
            </ButtonsContainer>
          </DescriptionTextColumnContentLeft>
          <DescriptionTextColumnContentRight>
            {slideshow && slideshow.length > 0 && (
              <React.Suspense>
                <ResponsiveSlideshow
                  items={slideshow}
                  variant="gray"
                  dataContentName="slideshow"
                />
              </React.Suspense>
            )}
          </DescriptionTextColumnContentRight>
        </DescriptionTextColumnContent>
      </DescriptionTextColumn>
    </SectionContainer>
  );
};

export default ShipIntro;
